import _ from 'lodash';

import { ValidationError } from 'jsonschema';



export function getValidationErrorPropertyPath(err: ValidationError): string {
  let prop = err.property.replace(/^instance\./, '');
  if (err.name === 'required' && err.argument) {
    prop = prop ? `${prop}.${String(err.argument)}` : String(err.argument);
  }
  return prop;
}



export function flattenValidationErrors(errors: ValidationError[]): ValidationError[] {
  const all: ValidationError[] = [];

  function traverse(errs: ValidationError[]) {
    _.forEach(errs, err => {
      const errWithInner = err as unknown as { inner?: ValidationError[]; };
      const inner: ValidationError[] = errWithInner.inner ?? [];
      if (!_.isEmpty(inner)) {
        traverse(inner);
        if (err.name === 'oneOf' || err.name === 'anyOf') {
          return;
        }
      }
      all.push(err);
    });
  }
  traverse(errors);

  const msg = (e: ValidationError) => (e.message ?? e.toString());
  const isActionable = (e: ValidationError) =>
    !msg(e).includes('is not exactly one from') &&
    !msg(e).includes('is not any of') &&
    !msg(e).includes('is not of a type(s) null');

  const filtered = all.filter(isActionable);

  const byPath = new Map<string, ValidationError>();
  for (const err of filtered) {
    const prop = getValidationErrorPropertyPath(err);
    const existing = byPath.get(prop);
    if (!existing || prop.length > getValidationErrorPropertyPath(existing).length) {
      byPath.set(prop, err);
    }
  }

  const paths = Array.from(byPath.keys());
  for (const p of paths) {
    const hasChild = paths.some(other => other !== p && other.startsWith(p + '.'));
    if (hasChild) {
      byPath.delete(p);
    }
  }

  return Array.from(byPath.values());
}
